import type { ReactNode } from "react";
import { useCreatorContext } from "@/lib/ambassadors/creatorLinks";

export function CreatorBoostHalo({ children, label }: { children: ReactNode; label?: string }) {
  const ctx = useCreatorContext();
  if (!ctx.active) return <>{children}</>;
  const accent = ctx.nation === "BRA" ? "#FFCC29"
    : ctx.nation === "ARG" ? "#75AADB"
    : ctx.nation === "MEX" ? "#1B8A2C"
    : "#E94560";
  return (
    <div className="relative">
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-1 rounded-3xl opacity-70 blur-md"
        style={{ background: `radial-gradient(60% 60% at 50% 0%, ${accent}55, transparent 70%)` }}
      />
      <div className="relative">{children}</div>
      {label && (
        <div
          className="absolute -top-2 left-3 rounded-full px-2 py-0.5 text-[9px] font-black uppercase tracking-wider"
          style={{ background: accent, color: "#000" }}
        >
          {label}
        </div>
      )}
    </div>
  );
}
